import { Network } from "../../network";
import { NFT, toNFTCollectionName } from "../nft";
export const magicedenAssetToNFT = (asset, owner) => {
    return new NFT({
        owners: [{ address: owner, quantity: 1 }],
        name: asset.name,
        network: Network.SOLANA,
        collectionId: asset.collection || toNFTCollectionName(asset.collectionName || ""),
        tokenId: asset.mintAddress,
        imageUrl: asset.image,
        attributes: asset.attributes.map((trait) => ({
            traitType: trait.trait_type,
            value: trait.value,
        })),
    });
};
